import { utils, writeFile } from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export interface ExportColumn<T> {
  key: keyof T | string;
  label: string;
  formatter?: (value: any, row: T) => string | number;
}

function buildTableData<T>(columns: ExportColumn<T>[], rows: T[]) {
  return rows.map((row) =>
    columns.map((column) => {
      const value = (row as any)[column.key as keyof T];
      return column.formatter ? column.formatter(value, row) : value ?? '';
    })
  );
}

export function exportToCSV<T>(filename: string, columns: ExportColumn<T>[], rows: T[]) {
  const header = columns.map((c) => c.label);
  const data = buildTableData(columns, rows);
  const worksheet = utils.aoa_to_sheet([header, ...data]);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Report');
  writeFile(workbook, `${filename}.csv`, { bookType: 'csv' });
}

export function exportToExcel<T>(filename: string, columns: ExportColumn<T>[], rows: T[]) {
  const header = columns.map((c) => c.label);
  const data = buildTableData(columns, rows);
  const worksheet = utils.aoa_to_sheet([header, ...data]);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Report');
  writeFile(workbook, `${filename}.xlsx`, { bookType: 'xlsx' });
}

export function exportToPDF<T>(filename: string, title: string, columns: ExportColumn<T>[], rows: T[]) {
  const doc = new jsPDF({ orientation: 'landscape' });
  const tableColumn = columns.map((c) => c.label);
  const tableRows = buildTableData(columns, rows);

  doc.setFontSize(16);
  doc.text(title, 14, 20);

  autoTable(doc, {
    startY: 28,
    head: [tableColumn],
    body: tableRows,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [236, 72, 153] },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    tableWidth: 'auto',
  });

  doc.save(`${filename}.pdf`);
}
